import { IResponsiblePurchasingGroupDto } from '../types/responsible-purchasing-group.dto';

/**
 * EPROC-11622: the purchasing group responsible for a company code and commodity group combination,
 * used for read-only derivation previews. `assigned` is false when the tenant has no responsibility
 * for the combination, so a caller can tell "nothing assigned" apart from "not looked up yet".
 */
export class ResponsiblePurchasingGroup {
    public readonly code: string | null;
    public readonly name: string | null;
    public readonly assigned: boolean;

    constructor(dto: IResponsiblePurchasingGroupDto) {
        this.code = dto.code ?? null;
        this.name = dto.name ?? null;
        this.assigned = !!this.code;
    }
}
